import * as Yup from 'yup'

import { FORM_ERRORS } from '~/const'

export const validationSchema = Yup.object({
  placements: Yup.array().of(
    Yup.object({
      navigationGraph: Yup.object({
        label: Yup.string(),
        value: Yup.string(),
      })
        .default(undefined)
        .required(FORM_ERRORS.REQUIRED),
      placement: Yup.object({
        label: Yup.string(),
        value: Yup.string(),
      })
        .default(undefined)
        .required(FORM_ERRORS.REQUIRED),
    })
  ),
})
